import {Injectable} from "@angular/core";
import _ from "lodash";
import {PermissionNumbers} from "../../enums/permissions/permissionNumbers.enum";

@Injectable({providedIn: "root"})
export class PermissionInternationalReceiversService {

  constructor() {
  }


  hasInternationalPermission(contract: any): boolean {
    return this.hasInternationalPermissionByNomina(contract) && this.hasInternationalNumberPermission(contract);
  }

  private hasInternationalPermissionByNomina(contractSelected: any) {
    return !(contractSelected && contractSelected.nomina);
  }

  private hasInternationalNumberPermission(contract: any): boolean {
    if (contract) {
      const contractsString: any = sessionStorage.getItem("PERMISSIONS") || "{}";
      const receiverInternationalPermission = PermissionNumbers.INTERNATIONAL_RECEIVER;
      const contracts = JSON.parse(contractsString)
      if (!contracts || contracts.length === 0) return false;
      const contractPermissions = contracts[contract.idContrato] || [];
      if (!contractPermissions || contractPermissions.length === 0) return false;
      return _.includes(contractPermissions, receiverInternationalPermission);
    } else {
      return false
    }

  }
}
